// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { ApiHttpService } from 'src/app/core/services/api-http.service';
//import { DummyHttpService } from 'src/app/core/services/dummy-http.service';

export const environment = {
  production: false,
  local: true,
  //httpServiceType: DummyHttpService,
  httpServiceType: ApiHttpService,
  API_ENDPOINT_LECTURA:
    'https://affinity-petcare-sa-produccion-affinity-cepa-produccion71bc0a7f.cfapps.eu10.hana.ondemand.com/store-locator',
  API_ENDPOINT_ESCRITURA:
    'https://affinity-petcare-sa-produccion-affinity-cepa-produccion71bc0a7f.cfapps.eu10.hana.ondemand.com/store-locator',
  API_ME: 'http://localhost:3000',
  API_KEY: '5ppphGQj1pzQ9A0ntttML70JHkGjGhl7',
  CLIENT_ID: 'sb-StoreLocatorCAP!t35937',
  CLIENT_SECRET: 'IST4LCrL77zaeSLl4dUl2NxprXM=',
  OAUTH_URL:
    'https://produccion.authentication.eu10.hana.ondemand.com/oauth/token',
  GET_ADMINS_URL: 'http://localhost:3000/membersOCM',
  GET_TOKEN_OCM: 'http://localhost:3000/tokenOCM',
  GET_CONNECTIONS: 'http://localhost:3000/connectionsOCM',
  GET_USER_GROUPS:
    'https://bc-affinitycontent.cec.ocp.oraclecloud.com/osn/fc/RemoteJSONBatch',
  GOOGLE_MAPS_API_KEY: 'AIzaSyA5TOEeoXQw2BNq5DJKin96hTmAyk1bfrQ',
  azure: {
    clientId: 'c985ad49-a62e-4f22-9848-5ed1f0ec1fe6',
    tenantId: 'e404e285-6ce2-49df-8319-090db24b60d4',
    redirectUri: 'https://storelocator-uat.affinity-petcare.com/',
    redirectUriLogout: 'https://storelocator-uat.affinity-petcare.com',
    scopes: ['User.Read']
  },
  adminRoleId: '6ec7f1e8-5aa1-4537-8c4d-d9d859d76dac',

  // GOOGLE_MAPS_API_KEY: 'AIzaSyCURJnUieylO9cZOpX008ZAQnt2fYqI40w', //local
  // azure: {
  //   clientId: '65d0ff5a-64cf-4c19-929c-3cbda253f69a',
  //   tenantId: 'ce487c9c-6f6c-417f-9d57-fc5f02d38cd4',
  //   redirectUri: 'http://localhost:4290',
  //   redirectUriLogout: 'http://localhost:4290',
  //   scopes: ['User.Read']
  // }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
